import { Route, Routes as BaseRoutes } from "react-router-dom";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";

export default function Routes() {
  return (
    <BaseRoutes>
      <Route path="/" element={<Home />} />
      <Route path="privacy">
        <Route index element={<Privacy />} />
      </Route>
    </BaseRoutes>
  );
}
